import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { STEPS } from "../../../constants/enums";
import { toastMessage } from "../../../helper";
import { getAssetListService } from "../../../services/assetService";
import EmptyList from "../../common/EmptyList";

const AssetsScopeSelection = (props: any) => {
  const {
    assetsList,
    setStep,
    setSelectedAssetsData,
    handleMouseEnterProceed,
    handleMouseLeaveProceed,
    setAssetsList,
  } = props;
  const [searchText, setSearchText] = useState("");
  const [assetsCount, setAssetsCount] = useState(0);
  const cellColumns = ["Assets ID", "Assets name", "Assets type", "Status"];
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };
  useEffect(() => {
    const reqObj = {
      controller: controller,
      searchText: searchText,
    };
    getAssetListService(reqObj)
      .then((res) => {
        const data = res.data;
        const assetsList = data.assets;
        setAssetsCount(data.total_count);
        setAssetsList([...assetsList]);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  }, [controller, searchText]);

  return (
    <div className="pw-scope-main w-55v overflow-y-auto">
      <div className="pw-input-label pw-create-label pw-text-neutral-900 ">
        {t("Select Assets")}
      </div>
      <div className="pw-bunit-create-desc pw-border-bottom pb-2 pw-text-neutral-700">
        {t("Once selected cannot be edited in later stages")}
      </div>

      <div className="pw-scope-left-div flex flex-col">
        {assetsList && !assetsList?.length && searchText === "" ? (
          <div className="m-auto pt-48">No Assets Found</div>
        ) : (
          <div>
            <OutlinedInput
              id="outlined-adornment-password "
              style={{ background: "#fff", width: "20rem" }}
              className="pw-scope-search-field mb-4"
              placeholder={t("Search")}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  {searchText === "" ? (
                    <IconButton edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton onClick={() => setSearchText("")} edge="end">
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {/* //list */}
            <TableContainer>
              <Table className="pw-emission-table pw-row-hover">
                <TableHead>
                  <TableRow className="pw-bg-neutral-50 p-2">
                    {cellColumns.map((eachCell, index) => (
                      <TableCell
                        key={index}
                        className={`  ${
                          eachCell === "active" && "pw-color-primary"
                        } pw-thead-list ${
                          eachCell === "Category" ? "pw-row" : ""
                        } ${eachCell === "Modified On" ? "pw-date-row" : ""}`}
                        align={`${
                          eachCell === "EmissionID" ||
                          eachCell === "Value(kg CO2e)"
                            ? "right"
                            : "left"
                        }`}
                      >
                        {t(eachCell)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {assetsList.map((each: any, index: any) => {
                    return (
                      <TableRow
                        className="flex items-center"
                        onMouseEnter={() => handleMouseEnterProceed(index)}
                        onMouseLeave={() => handleMouseLeaveProceed(index)}
                        style={{ background: "#fff", height: "5rem" }}
                      >
                        <TableCell>{each.local_code}</TableCell>
                        <TableCell>{each.name}</TableCell>
                        <TableCell>{each.type}</TableCell>
                        <TableCell>
                          <div
                            className={`  flex justify-between items-center ${
                              !each.disabled && "pw-color-primary"
                            }   `}
                          >
                            <div> {each.disabled ? "InActive" : "Active"}</div>
                            {!each.disabled && each.isHovered && (
                              <div
                                onClick={() => {
                                  setStep(STEPS.ASSETS);
                                  setSelectedAssetsData({
                                    id: each.id,
                                    code: each.local_code,
                                    generatedCode: each.code,
                                  });
                                }}
                                className={`flex items-center gap-x-2  pw-proceed-button`}
                              >
                                <div className="text-bold">Proceed</div>
                                <div>
                                  <img
                                    src="assets/icons/arrow-right.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            {!assetsList?.length ? (
              <div className="flex justify-center items-center h-full bg-white">
                <EmptyList />
              </div>
            ) : (
              ""
            )}
            {(assetsCount >= 10 || controller.page > 0) && (
              <TablePagination
                component="div"
                count={assetsCount}
                page={controller.page}
                colSpan={5}
                onPageChange={handlePageChange}
                rowsPerPage={controller.limit}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage=""
                className="flex flex-row justify-end pw-pagination "
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default AssetsScopeSelection;
